import { use } from 'react';
import { WhatsNewContext } from './WhatsNewContext.ts';

/**
 * {@link useWhatsNew} connects the account-menu entry to the panel, which is rooted at the layout
 * rather than inside the menu so it outlives the menu closing.
 */
export function useWhatsNew() {
  const context = use(WhatsNewContext);
  if (context === undefined) {
    throw new Error('useWhatsNew must be used within a WhatsNewProvider');
  }
  return context;
}
